import { render, staticRenderFns } from "./CopyAssetsDestinationView.vue?vue&type=template&id=37dbbe7b&scoped=true"
import script from "./CopyAssetsDestinationView.vue?vue&type=script&lang=js"
export * from "./CopyAssetsDestinationView.vue?vue&type=script&lang=js"
import style0 from "./CopyAssetsDestinationView.vue?vue&type=style&index=0&id=37dbbe7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dbbe7b",
  null
  
)

export default component.exports